import React, { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const [quickLinksOpen, setQuickLinksOpen] = useState(false);
  const [legalOpen, setLegalOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const quickLinks = [
    { to: "/about", label: "About Us" },
    { to: "/service", label: "Services" },
    { to: "/career", label: "Careers" },
    { to: "/", label: "Media" },
    { to: "/contact", label: "Contact" },
  ];

  const legalLinks = [
    { to: "/privacy-policy", label: "Privacy Policy" },
    { to: "/terms-conditions", label: "Terms & Conditions" },
    { to: "/grievance-redressal-policy", label: "Grievance Redressal" },
    { to: "/fair-practice-code", label: "Fair Practices Code" },
    { to: "/", label: "Disclaimer" },
  ];

  const services = [
    { to: "/", label: "Business Loans" },
    { to: "/", label: "Property Finance" },
    { to: "/", label: "Personal Loans" },
    { to: "/", label: "Working Capital" },
    { to: "/", label: "Invoice Financing" },
  ];

  const linkClass =
    "text-sm md:text-base text-white hover:text-gray-300 transition-colors duration-200 no-underline";

  return (
    <footer className="w-full bg-[#1A1A1A] text-white">
      {/* Main Content - 4 Columns */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1: Company Information with Logo */}
          <div className="space-y-4">
            <Link
              to="/"
              onClick={scrollToTop}
              className="flex items-center gap-3 mb-4 cursor-pointer hover:opacity-90 transition-opacity no-underline outline-none border-none"
            >
              {/* Logo */}
              <img
                src="/newlogo.png"
                alt="Pawansut Holdings Logo"
                className="h-16 w-auto object-contain block"
              />
              <span
                className="text-white text-base font-semibold tracking-wide"
                style={{ fontFamily: "Inter, sans-serif" }}
              >
                
              </span>
            </Link>
            <p className="text-sm md:text-base text-white leading-relaxed">
              Your trusted partner in financial growth. RBI-registered NBFC
              providing innovative solutions across India. RBI Registration:
              NBFC-ND-SI Reg No: N-14.12345
            </p>
          </div>

          {/* Column 2: Legal */}
          <div className="space-y-4">
            <button
              onClick={() => setLegalOpen(!legalOpen)}
              className="md:hidden w-full flex items-center justify-between text-base font-bold text-white mb-4 py-2"
            >
              <span>Legal</span>
              <svg
                className={`w-5 h-5 transition-transform duration-200 ${
                  legalOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <h3 className="hidden md:block text-base font-bold text-white mb-4">
              Legal
            </h3>
            <ul
              className={`space-y-2 ${legalOpen ? "block" : "hidden"} md:block`}
            >
              {legalLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={scrollToTop}
                    className={linkClass}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Quick Links */}
          <div className="space-y-4">
            <button
              onClick={() => setQuickLinksOpen(!quickLinksOpen)}
              className="md:hidden w-full flex items-center justify-between text-base font-bold text-white mb-4 py-2"
            >
              <span>Quick Links</span>
              <svg
                className={`w-5 h-5 transition-transform duration-200 ${
                  quickLinksOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <h3 className="hidden md:block text-base font-bold text-white mb-4">
              Quick Links
            </h3>
            <ul
              className={`space-y-2 ${quickLinksOpen ? "block" : "hidden"} md:block`}
            >
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={scrollToTop}
                    className={linkClass}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Our Services */}
          <div className="space-y-4">
            <button
              onClick={() => setServicesOpen(!servicesOpen)}
              className="md:hidden w-full flex items-center justify-between text-base font-bold text-white mb-4 py-2"
            >
              <span>Our Services</span>
              <svg
                className={`w-5 h-5 transition-transform duration-200 ${
                  servicesOpen ? "rotate-180" : ""
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            <h3 className="hidden md:block text-base font-bold text-white mb-4">
              Our Services
            </h3>
            <ul
              className={`space-y-2 ${servicesOpen ? "block" : "hidden"} md:block`}
            >
              {services.map((item, index) => (
                <li key={index}>
                  <Link
                    to={item.to}
                    onClick={scrollToTop}
                    className={linkClass}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Separator Line */}
      <div className="border-t border-white/20 max-w-7xl mx-auto px-6 lg:px-12" />

      {/* Bottom Bar - Copyright and Social Media */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 md:py-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div
            className="text-xs md:text-sm text-white text-center md:text-left tracking-wide"
            style={{ fontFamily: "Inter, sans-serif" }}
          >
            © 2026 Pawan Sut NBFC. All rights reserved.
          </div>
          <div className="flex items-center gap-3">
            {/* Facebook */}
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold hover:bg-blue-700 transition-colors"
            >
              f
            </a>
            {/* LinkedIn */}
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold hover:bg-blue-700 transition-colors"
            >
              in
            </a>
            {/* Twitter/X */}
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold hover:bg-blue-700 transition-colors"
            >
              X
            </a>
            {/* Instagram */}
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold hover:bg-blue-700 transition-colors"
            >
              IG
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
